/** Role granted when adding a parent-team member to a class (plan F2). */
export enum CLASS_MEMBER_ROLE {
  STUDENT = 'student',
  TEACHER = 'teacher'
}

/** Kind of allow-list entry used for normalize / duplicate checks. */
export enum ALLOWLIST_ITEM_KIND {
  APP = 'app',
  URL = 'url'
}

/** Why "Start focus session" is disabled on the class page. */
export enum CLASS_START_BLOCK_REASON {
  LIVE_UPDATES_UNAVAILABLE = 'live_updates_unavailable',
  OUTSIDE_SESSION_WINDOW = 'outside_session_window'
}

/** Class report engagement band, derived from a student's average focus. */
export enum ENGAGEMENT_BAND {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
  NO_DATA = 'no_data'
}
